import { jsPDF } from "jspdf";
import "jspdf-autotable";

export function exportCSV(alerts, filename = "guard_alerts.csv") {
  const headers = ["Type", "Description", "Latitude", "Longitude", "Reporter", "Status", "Date"];
  const rows = alerts.map((a) => [
    a.alert_type,
    `"${(a.description || "").replace(/"/g, '""')}"`,
    a.latitude,
    a.longitude,
    a.user_name || "",
    a.status,
    new Date(a.created_at).toLocaleString(),
  ]);

  const csv = [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function exportPDF(alerts, title = "Guard Emergency Reports") {
  const doc = new jsPDF({ orientation: "landscape" });

  // Title
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text(title, 14, 18);

  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(`Generated: ${new Date().toLocaleString()} | Total: ${alerts.length} alerts`, 14, 25);

  // Table
  const headers = [["Type", "Description", "Coordinates", "Reporter", "Status", "Date"]];
  const rows = alerts.map((a) => [
    a.alert_type.toUpperCase(),
    (a.description || "").slice(0, 60) + ((a.description || "").length > 60 ? "..." : ""),
    `${a.latitude.toFixed(4)}, ${a.longitude.toFixed(4)}`,
    a.user_name || "-",
    a.status,
    new Date(a.created_at).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }),
  ]);

  const typeColorMap = {
    SECURITY: [239, 68, 68],
    FIRE: [249, 115, 22],
    MEDICAL: [59, 130, 246],
    ACCIDENT: [234, 179, 8],
  };

  doc.autoTable({
    head: headers,
    body: rows,
    startY: 30,
    theme: "grid",
    styles: { fontSize: 8, cellPadding: 2, font: "helvetica" },
    headStyles: { fillColor: [17, 24, 39], textColor: 255, fontStyle: "bold", fontSize: 8 },
    columnStyles: {
      0: { cellWidth: 22 },
      1: { cellWidth: 80 },
      4: { cellWidth: 20 },
    },
    didParseCell: (data) => {
      if (data.section === "body" && data.column.index === 0) {
        const color = typeColorMap[data.cell.raw] || [107, 114, 128];
        data.cell.styles.textColor = color;
        data.cell.styles.fontStyle = "bold";
      }
      if (data.section === "body" && data.column.index === 4) {
        if (data.cell.raw === "active") {
          data.cell.styles.textColor = [239, 68, 68];
          data.cell.styles.fontStyle = "bold";
        } else {
          data.cell.styles.textColor = [22, 163, 74];
        }
      }
    },
    alternateRowStyles: { fillColor: [249, 250, 251] },
  });

  doc.save("guard_alerts.pdf");
}
